<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{ plot ? $t('main.title_edit_element')+":" : $t('main.title_add_element')+":" }}
        {{ $t('admin.views.plots.title') }}
      </template>
      <template #actions>
        <Loading
          v-if="loadingSaveData"
          class="mb-2"
        />
        <div class="form-group flex flex-wrap items-center gap-3">
          <button
            @click="saveData"
            type="button"
            class="btn btn-small btn-green"
          >
            {{ $t('main.button_save') }}
          </button>
          <router-link
            class="btn btn-small btn-default"
            :to="{
              name: 'plots',
              query: $route.query
            }"
          >{{ $t('main.button_cancel') }}</router-link>
        </div>
      </template>
    </AdminStickyHeader>
    <div class="form">
      <div class="form-group">
        <label
          for="name"
          class="font-bold"
        >{{ $t('admin.views.plots.sizes') }} *:</label>
        <div class="cm flex items-end mr-30 mb-4">
          <div class="size-data-block width">
            <label for="width">{{ $t('main.width_sm') }}:</label>
            <input
              v-model="form.width"
              type="text"
              id="width"
              placeholder="000"
            />
            <ValidationErrors :errors="errorsFor('width')" />
          </div>
          <div class="x mb-3 ml-1">X</div>
          <div class="size-data-block length ml-1">
            <label for="length">{{ $t('main.length_sm') }}:</label>
            <input
              type="text"
              id="length"
              v-model="form.length"
              placeholder="000"
            />
            <ValidationErrors :errors="errorsFor('length')" />
          </div>
        </div>
      </div>
      <div class="form-group">
        <button
          class="
                    rounded
                    flex
                    justify-center
                    items-center
                    focus:outline-none
                  "
          type="button"
          @click="
                    form.is_default =
                      form.is_default == 1?0:1
                  "
        >
          <span class="check"><i
              v-if="form.is_default == 1"
              class="fas fa-check text-red-500"
            ></i></span>
          <span class="ml-2 text-sm">{{$t('main.by_default')}}</span>
        </button>
      </div>
      <div class="form-group">
        <label class="font-bold">{{ $t('main.label_status') }}: </label>
        <div>
          <button
            class="rounded flex items-center focus:outline-none gap-2"
            type="button"
            @click="form.status = form.status == 1 ? 0 : 1"
          >
            <span class="check"><i
                v-if="form.status == 1"
                class="fas fa-check text-red-500"
              ></i></span>
            <span class="text-sm">{{$t('main.published')}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
import validationErrors from "../../../mixins/validationErrors";
export default {
  name: "Form",
  components: { AdminStickyHeader },
  mixins: [validationErrors],
  props: {
    plot: {
      type: Object,
    },
  },
  data() {
    return {
      loadingSaveData: false,
      form: {
        width: this.plot ? this.plot.width : "",
        length: this.plot ? this.plot.length : "",
        is_default: this.plot ? this.plot.is_default : 0,
        status: this.plot ? parseInt(this.plot.status) : 1,
      },
    };
  },
  mounted() {
    // if (!this.licensed) this.$router.push({ name: "no_license" });
  },
  computed: {
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;
      try {
        let formDataPost = new FormData();

        if (this.plot) formDataPost.append("_method", "PATCH");

        if (this.form.width !== null) {
          formDataPost.append("width", this.form.width);
        }

        if (this.form.length !== null) {
          formDataPost.append("length", this.form.length);
        }

        formDataPost.append("is_default", parseInt(this.form.is_default));
        formDataPost.append("status", parseInt(this.form.status));

        let url = `/api/admin/plots`;
        if (this.plot) url = `/api/admin/plots/${this.plot.plot_id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;
        const plotId = res?.data?.plot?.plot_id;
        if (!plotId) {
          throw new Error("Некорректный ответ сервера");
        }

        if (!this.plot) {
          await this.$router
            .replace({
              name: "edit_plot",
              params: { plot_id: plotId },
              query: this.$route.query,
            })
            .catch((e) => {});
        }
      } catch (error) {
        this.errors = error?.response?.data?.errors || null;
        this.status = error?.response?.status || null;
        const notification = {
          type: "error",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Ошибка при сохранении",
        };
        this.$store.dispatch("notification/add", notification, {
          root: true,
        });
      }
      this.loadingSaveData = false;
    },
  },
};
</script>
